// extracted by mini-css-extract-plugin
export default {"card":"style_card__6gakJ","title":"style_title__W9DGx","text":"style_text__gmAOk","icon":"style_icon__WBUhX","arrow_icon":"style_arrow_icon__MeGSP"};